export default "__VITE_ASSET__BjrTpFIL__"